<template>
    <el-main>
        <query-gather
            :is-add="authorityMap.isAdd" 
            :is-input="true" 
            :is-query="true" 
            :is-reset="true"
            :cur-input-tip="curInputTip"
            style="margin-top: -2vh"
            @qgAddDeal="addItemDeal" 
            @qgQueryDeal="qgQuery"
            @qgResetDeal="resetLxDataDeal"
        >
        </query-gather>
        <div class="commonDiv">
            <el-table
                :data="lxTableData"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                border
                ref="ryTableRef"
                size="mini"
                :row-style="tableRowClassName"
                style="width: 100%;"
                height="calc(100% - 60px)"
                :header-cell-style="{backgroundColor:'#f9f9ff',fontSize: '1.4rem',textAlign:'center',color:'#323232',fontFamily:'PingFang SC',fontWeight:'normal',fontStretch:'normal',height:'6.5vh'}"
            >
                <el-table-column prop="mc" label="路线名称" align="center" width="200">
                    <template slot-scope="scope">
                        <span style="color: #46adf5;cursor: pointer;" @click="seeXclx(scope.row)">{{ scope.row.mc }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="ms" label="路线描述" align="center"/>
                <el-table-column prop="no" label="序号" align="center" width="60"/>
                <el-table-column label="操作" align="center" width="150" v-if="authorityMap.isDel">
                    <template slot-scope="scope">
                    <el-tooltip content="删除" effect="light" v-if="authorityMap.isDel">
                        <el-popconfirm
                            title="确定删除吗？"
                            @confirm="lxItemDeleteDeal(scope.row)"
                        >
                        <img
                            src="~@/assets/images/operates/delete.png"
                            alt=""
                            slot="reference"
                            style="cursor: pointer;width: 3.5vh;height: 3.5vh;"
                        />
                        </el-popconfirm>
                    </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="commonPage2">
                <el-pagination
                    @size-change="lxHandleSizeChange"
                    @current-change="gzHandleCurrentChange"
                    :page-sizes="[10, 20, 30]"
                    :page-size="params.size"
                    :current-page="params.current"
                    layout="total, prev, pager, next,sizes, jumper"
                    background
                    :total="params.total"
                >
                </el-pagination>
            </div>
        </div>
        <data-dialog
            :dialog-title="lxDialog.title" 
            :is-visible="lxDialog.ryFormVisible" 
            :is-read="isRead"
            @dgVerifyDeal="dgVerifyDeal('lxDialog','dialog')" 
            ref="lxDialog" 
            @dgConfirmDeal="dgRyConfirmDeal"
            @dgCancelDeal="dgCancelDeal"
            :dgStyle="dgSmallStyle"
            :is-own-style="true"
        >
            <div slot="dialogFrom">
                <el-form
                    ref="dialog" 
                    :model="lxDialog.data" 
                    :rules="lxRules" 
                    label-position="top"
                    :disabled="isRead"
                >
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="路线名称" prop="mc" style="width: 100%;">
                                <el-input v-model="lxDialog.data.mc" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="路线描述" prop="ms" style="width: 100%;">
                                <el-input v-model="lxDialog.data.ms" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="巡查点选择" prop="hycncdList" style="width: 100%;">
                                <div style="border-radius: 5px;border: 2px solid #e4e4e5;">
                                    <div style="background-color: #f6f7fb;height: 100%;width: 100%;">
                                        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" style="margin-left: 15px;">所有巡查点</el-checkbox>
                                    </div>
                                    <div style="margin: 15px;">
                                        <el-input v-model="xcdmc" clearable prefix-icon="el-icon-search" class="input-class" placeholder="请输入巡查点名称"></el-input>
                                    </div>
                                    <div style="margin: 0 15px;">
                                        <el-checkbox-group v-model="lxDialog.data.hycncdList">
                                            <el-checkbox v-for="xcd in xcds" :label="xcd.hycncd" :key="xcd.hycncd" style="display: block;">{{ xcd.hycnnm }}</el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="序号" prop="no" style="width: 100%;">
                                <el-input v-model="lxDialog.data.no" clearable></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </data-dialog>
    </el-main>
</template>
  
<script>
import DataDialog from "../../components/tableGather/dataDialog";
import QueryGather from "../../components/buttonGather/queryGather";
export default {
    components: {DataDialog, QueryGather},
    data() {
        let validateXhNum = (rule, value, callback) => {
            if (value == null || value.length == 0) {
                callback();
            } else {
                const reg = /^[0-9][0-9]*$/;
                if (reg.test(value)) {
                    value = value + '';
                    if (value.length > 9) {
                        return callback(new Error("序号长度不超过9个字符"));
                    }
                    callback();
                } else {
                    return callback(new Error("序号只能填0-9的数字"));
                }
            }
        };
        let validateMcLen = (rule, value, callback) => {
            if (value == null || value.length == 0) {
                callback();
            } else {
                if (value.length > 30) {
                    return callback(new Error("长度不能超过30个字符"));
                } else {
                    return callback();
                }
            }
        };
        let validateMsLen = (rule, value, callback) => {
            if (value == null || value.length == 0) {
                callback();
            } else {
                if (value.length > 100) {
                    return callback(new Error("长度不能超过100个字符"));
                } else {
                    return callback();
                }
            }
        };
        return {
            dgSmallStyle: {
                height: '60%',
                marginTop: '0px',
                width: '25vw',
            },
            authorityMap: {
                isAdd: false,//新增权限
                isUpdate: false,//修改权限
                isDel: false,//删除权限
                isView: false,//查看权限
            },
            isRead: false,
            stRemHeight: 0,
            curInputTip: '请输入路线名称',

            lxTableData: [],
            lxRules: {
                mc: [
                    {required: true, message: "请输入路线名称", trigger: "blur"},
                    {validator: validateMcLen, trigger: 'blur'},
                ],
                ms: [
                    {required: true, message: "请输入路线描述", trigger: "blur"},
                    {validator: validateMsLen, trigger: 'blur'},
                ],
                hycncdList: [
                    {required: true, message: "请选择巡查点", trigger: "blur"},
                    {validator: validateMcLen, trigger: 'blur'},
                ],
                no: [
                    {required: true, message: "请输入序号", trigger: "blur"},
                    {validator: validateXhNum, trigger: 'blur'},
                ],
            },
            params: {
                total: 1,
                size: 10,
                current: 1,
            },
            loading: false,
            lxMultiple: true,
            lxMultipleSelection: [],
            curInputValue: '',
            lxDialog: {
                title: "",
                ryFormVisible: false,
                data: {
                    mc: '',
                    ms: '',
                    hycncdList: [],
                    no: '',
                },
            },
            xcdmc:'',
            xcds:[],
            isIndeterminate: true,
            checkAll: false,
            dialogData: {
                mc: '',
                ms: '',
                hycncdList: [],
                no: '',
            },
        }
    },
    created() {
        let windowHeight = document.documentElement.clientHeight || document.bodyclientHeight;
        this.stRemHeight = windowHeight / 100;
    },
    mounted() {
        this.initStaffData();
        this.getXcdData();
    },
    watch: {
        "$store.state.head.skCd"() {
            this.resetLxDataDeal();
        }
    },
    methods: {
        initStaffData() {
            this.pageAuthorityDeal();
            this.getXcxlData();
        },
        pageAuthorityDeal() {
            const thirdAuthority = JSON.parse(localStorage.getItem("thirdAuthority"))
            const qx = thirdAuthority[this.$route.name];
            if (qx === 'all' || qx === null) {
                this.authorityMap.isAdd = true;
                this.authorityMap.isDel = true;
                this.authorityMap.isUpdate = true;
                this.authorityMap.isView = true;
            } else {
                this.authorityMap.isAdd = qx.indexOf('新增') !== -1;
                this.authorityMap.isDel = qx.indexOf('删除') !== -1;
                this.authorityMap.isUpdate = qx.indexOf('修改') !== -1;
                this.authorityMap.isView = qx.indexOf('查询') !== -1;
            }
        },
        tableRowClassName({row, rowIndex}) {
            return {
                backgroundColor: '#ffffff',
                fontSize: '1.4rem',
                fontWeight: 'normal',
                fontStretch: 'normal',
                fontFamily: 'PingFang SC',
                color: '#616f7b',
                height: '5.83vh',
            };
        },

        
        resetLxDataDeal() {
            this.curInputValue = '';
            this.clearTableStatus();
            this.getXcxlData();
        },
        clearTableStatus() {
            this.$refs.ryTableRef.clearSort();
        },
        initGetLxData() {
            this.params = {
                total: 0,
                size: 10,
                current: 1,
            };
            this.getXcxlData();
        },
        qgQuery(params) {
            this.curInputValue = params.curInputValue;
            this.params.current = 1;
            this.clearTableStatus();
            this.getXcxlData();
        },
        
        getXcxlData() {
            this.loading = true;
            let params = {
                ...this.params,
                'xmOrzh': this.curInputValue + '',
            }
            this.request.post('/rm-xxclx/queryXclxPage', params).then(res => {
                if (res.ok) {
                    if (res.data != null) {
                        this.lxTableData = [];
                        this.lxTableData = res.data['records'];
                    } else {
                        this.$message.info("暂无巡查路线！");
                    }
                } else {
                    this.$message.error(res.error.message);
                }
                this.loading = false;
            });
        },
        lxHandleSizeChange(val) {
            this.params.size = val;
            this.params.current = 1;
            this.getXcxlData();
        },
        gzHandleCurrentChange(val) {
            this.params.current = val;
            this.getXcxlData();
        },


        getXcdData(){
            this.request.get('/rm-breshycn/queryHycnChoose?hycnnm=', this.xcdmc).then(res => {
                if (res.ok) {
                    this.xcds = res.data;
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        dgVerifyDeal(dgRef, frRef) {
            this.$refs[frRef].validate((valid) => {
                if (valid) {
                    this.$refs[dgRef].isShowPop(true);
                } else {
                    this.$refs[dgRef].isShowPop(false);
                }
            });
        },
        dgCancelDeal() {
            if (this.lxDialog.ryFormVisible) {
                this.lxDialog.ryFormVisible = false;
                this.$refs['dialog'].clearValidate();
            }
        },
        dgRyConfirmDeal() {
            this.isRead = false;
            if (this.isAddData) {
                this.addLx();
            } else {
                this.updateLx();
            }
        },
                
        handleCheckAllChange(val) {
            this.checkedCities = val ? cityOptions : [];
            this.isIndeterminate = false;
        },
        addItemDeal() {
            this.lxDialog.title = '添加巡查路线';
            this.lxDialog.ryFormVisible = true;
            this.lxDialog.data = {...this.dialogData};
            this.isAddData = true;
            this.isRead = false;
        },
        addLx() {
            this.request.post('/rm-xxclx/addXclx', this.lxDialog.data).then(res => {
                if (res.ok) {
                    this.lxDialog.ryFormVisible = false;
                    this.lxDialog.data = {};
                    this.isAddData = false;
                    this.params = {
                        total: 0,
                        size: 10,
                        current: 1,
                    };
                    this.$message.success('添加巡查路线成功！');
                    this.getXcxlData();
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        
        seeXclx(row){
            this.request.get('/rm-xxclx/queryXclx/'+ row.id).then(res => {
                if (res.ok) {
                    this.lxDialog.data = {...res.data};
                    let aa = [];
                    for (let i = 0; i < res.data.hycnVOList.length; i++) {
                        aa[i] =  JSON.parse(JSON.stringify(res.data.hycnVOList[i].hycncd));
                    }
                    this.lxDialog.data = {
                        ...res.data,
                        hycncdList:aa,
                    };
                    this.lxDialog.title = '修改巡查路线';
                    this.lxDialog.ryFormVisible = true;
                    this.isAddData = false;
                    this.isRead = false;
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        updateLx() {
            this.request.post('/rm-xxclx/modifyXclx', this.lxDialog.data).then(res => {
                if (res.ok) {
                    this.lxDialog.ryFormVisible = false;
                    this.lxDialog.data = {};
                    this.isAddData = false;
                    this.params = {
                        total: 0,
                        size: 10,
                        current: 1,
                    };
                    this.$message.success('修改巡查路线成功！');
                    this.getXcxlData();
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
        lxItemDeleteDeal(row) {
            this.request.delete('/rm-xxclx/v1/' + row.id).then(res => {
                if (res.ok) {
                    this.$message.success("巡查路线删除成功");
                    this.initGetLxData();
                } else {
                    this.$message.error(res.error.message);
                }
            });
        },
    },
}
</script>
<style scoped>
.commonDiv {
    position: relative;
    background-color: #FFFFFF;
    height: calc(100vh - 200px);
}
::v-deep .el-pagination{
    white-space: nowrap;
    color: #303133;
    font-weight: 700;
    transform: translate(0, -50%);
    position: relative;
    top: 50%;
    right: 20px;
}
.commonPage2 {
    position: absolute;
    right: 1.5rem;
    height: 60px;
}

.input-class /deep/ .el-input__inner {
    border-radius: 30px;
}
</style>
  